const { NEXT_PUBLIC_APP_URL } = process.env;
const { NEXT_PUBLIC_GOOGLE_ANALYTICS_KEY } = process.env;
const { NEXT_PUBLIC_GOOGLE_MAPS_KEY } = process.env;
const { NEXT_PUBLIC_SETTINGS_APP_URL } = process.env;
const { NEXT_PUBLIC_RECAPTCHA_SITE_KEY } = process.env;

export const serverURL = NEXT_PUBLIC_APP_URL;
export const analyticsKey = NEXT_PUBLIC_GOOGLE_ANALYTICS_KEY;
export const mapsKey = NEXT_PUBLIC_GOOGLE_MAPS_KEY;
export const settingsAppUrl = NEXT_PUBLIC_SETTINGS_APP_URL;
export const recaptchaSiteKey = NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
